import { config } from "./config";

export const log: typeof console.log =
  config.environment === "production"
    ? (..._data: any[]) => { }
    : (...data: any[]) => {
      console.log(new Date().toISOString(), ...data);
    };
